import type { ConnectionsResponse, SocialPlatform } from '@pulsify/shared/dto'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { crosspostingApi } from '~/entities/crossposting/api/crossposting-api'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'

export function useConnections(businessId: string, listingId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.CROSSPOST_CONNECTIONS, businessId, listingId),
    queryFn: () => crosspostingApi.getConnections(businessId, listingId),
    enabled: !!businessId && !!listingId,
    staleTime: 30_000,
  })
}

export function useRefreshConnections(businessId: string, listingId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => crosspostingApi.refresh(businessId, listingId),
    onSuccess: (data: ConnectionsResponse) => {
      queryClient.setQueryData(
        queryKey(QueryKey.CROSSPOST_CONNECTIONS, businessId, listingId),
        data,
      )
    },
  })
}

export function useCreatePortalLink(businessId: string, listingId: string) {
  return useMutation({
    mutationFn: (platform: SocialPlatform) =>
      crosspostingApi.createPortalLink(businessId, listingId, platform),
  })
}

export function useDisconnectAccount(businessId: string, listingId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (platform: SocialPlatform) =>
      crosspostingApi.disconnect(businessId, listingId, platform),
    onSuccess: (data: ConnectionsResponse) => {
      queryClient.setQueryData(
        queryKey(QueryKey.CROSSPOST_CONNECTIONS, businessId, listingId),
        data,
      )
    },
  })
}
